"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.button.start': 'Rozpocznij onboarding',
    'onboarding.button.continue': 'Kontynuuj do Kroków',
    'onboarding.button.previous': 'Poprzedni',
    'onboarding.button.next': 'Następny',
    'onboarding.button.complete': 'Zakończ Onboarding',
};
